const styles = ({ typography }) => ({
  container: {
    height: '55vw',
    maxHeight: typography.pxToRem(934),
  },
});

export default styles;
